/**
 * ModulesTab — 28 Epicor modules with tool counts.
 *
 * Each module shows a colored dot, name, and tool count badge.
 * Clicking a module starts a new chat asking Trendy to explore
 * that module's capabilities.
 *
 * The tool counts come from Trendy's actual registered tools (~259 total).
 */

const MODULE_LIST = [
  { name: 'Customers', count: 9, color: '#8B5CF6' },
  { name: 'Sales Orders', count: 6, color: '#3B82F6' },
  { name: 'Quoting', count: 5, color: '#10B981' },
  { name: 'Jobs & Production', count: 8, color: '#F97316' },
  { name: 'Parts & Inventory', count: 9, color: '#06B6D4' },
  { name: 'AR & Invoicing', count: 18, color: '#22C55E' },
  { name: 'AP & Payments', count: 11, color: '#EF4444' },
  { name: 'Purchasing', count: 5, color: '#6366F1' },
  { name: 'Shipping', count: 5, color: '#14B8A6' },
  { name: 'Engineering', count: 9, color: '#0EA5E9' },
  { name: 'Quality', count: 7, color: '#F59E0B' },
  { name: 'RMA', count: 3, color: '#EF4444' },
  { name: 'General Ledger', count: 11, color: '#64748B' },
  { name: 'Labor', count: 4, color: '#8B5CF6' },
  { name: 'Shop Floor', count: 1, color: '#14B8A6' },
  { name: 'Planning', count: 5, color: '#06B6D4' },
  { name: 'Analytics', count: 9, color: '#D946EF' },
  { name: 'Documents', count: 8, color: '#A855F7' },
  { name: 'Attachments', count: 18, color: '#EC4899' },
  { name: 'Import Costing', count: 8, color: '#F97316' },
  { name: 'Email & Calendar', count: 10, color: '#3B82F6' },
  { name: 'Banking', count: 4, color: '#10B981' },
  { name: 'Config', count: 11, color: '#6366F1' },
  { name: 'Cross-References', count: 4, color: '#F43F5E' },
  { name: 'Containers', count: 3, color: '#0EA5E9' },
  { name: 'Tasks', count: 2, color: '#84CC16' },
  { name: 'Relationships', count: 1, color: '#E879F9' },
  { name: 'Intelligence', count: 4, color: '#FBBF24' },
]

// Total tool count for the header
const TOTAL_TOOLS = MODULE_LIST.reduce((sum, m) => sum + m.count, 0)

export default function ModulesTab({ onStartChat }) {
  const handleModuleClick = (moduleName) => {
    const prompt = `I want to explore the ${moduleName} module. Show me what Agents and capabilities you have available for ${moduleName}. List each Agent with a brief description of what it does, and give me an example of something I can ask you about ${moduleName}.`
    onStartChat(prompt)
  }

  return (
    <div className="p-3 flex flex-col gap-1">
      {/* Summary badge */}
      <div className="flex items-center justify-between px-2 py-2 mb-1">
        <span className="text-[11px] font-semibold text-gray-500 dark:text-gray-400 uppercase tracking-wider">
          {MODULE_LIST.length} Modules
        </span>
        <span className="text-[11px] font-mono font-medium text-gray-400 dark:text-gray-500 bg-gray-100 dark:bg-surface-dark-overlay px-2 py-0.5 rounded-full">
          {TOTAL_TOOLS} agents
        </span>
      </div>

      {MODULE_LIST.map((mod) => (
        <button
          key={mod.name}
          onClick={() => handleModuleClick(mod.name)}
          className="w-full flex items-center gap-2.5 px-2.5 py-2 rounded-lg cursor-pointer hover:bg-gray-100 dark:hover:bg-surface-dark-raised transition-all duration-100 group text-left"
        >
          <div
            className="w-2 h-2 rounded-full flex-shrink-0"
            style={{ background: mod.color }}
          />
          <span className="flex-1 text-[13px] font-medium text-gray-600 dark:text-gray-300 group-hover:text-gray-900 dark:group-hover:text-gray-100 transition-colors">
            {mod.name}
          </span>
          <span className="font-mono text-[11px] font-medium text-gray-400 dark:text-gray-500 bg-gray-100 dark:bg-surface-dark-overlay px-1.5 py-0.5 rounded">
            {mod.count}
          </span>
        </button>
      ))}
    </div>
  )
}

export { MODULE_LIST }
